import { MessageCircle } from "lucide-react";
import { SITE } from "@/constants/site";

export default function WhatsAppButton() {
  const href = `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent("Hi! I'd like to know more about Advanced Coaching sessions for my child.")}`;
  return (
    <a
      data-testid="whatsapp-floating-btn"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <div className="relative">
        <span className="absolute inset-0 rounded-full bg-emerald-500/40 animate-ping" />
        <div className="relative w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-400 transition-colors grid place-items-center shadow-[0_10px_30px_rgba(16,185,129,0.45)]">
          <MessageCircle className="w-6 h-6 text-white" />
        </div>
      </div>
      <span className="hidden md:block absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap text-xs font-semibold uppercase tracking-widest bg-white/95 text-slate-900 px-3 py-2 rounded-full opacity-0 group-hover:opacity-100 transition">
        Chat with us
      </span>
    </a>
  );
}
